import { Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appProgressImg]'
})

export class ProgressImgDirective implements OnInit, OnChanges {
  @Input() progress: number;

  constructor(private el: ElementRef) { }

  ngOnInit() {
    this.el.nativeElement.src = this.getImgUrl(this.progress);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.progress = changes.progress.currentValue;
    this.el.nativeElement.src = this.getImgUrl(this.progress);
  }

  private getImgUrl(progress: number) {
    if (progress < 25) {
      return 'assets/images/progress-pie-0.svg';
    } else if (progress < 50) {
      return 'assets/images/progress-pie-25.svg';
    } else if (progress < 75) {
      return 'assets/images/progress-pie-50.svg';
    } else if (progress < 100) {
      return 'assets/images/progress-pie-75.svg';
    } else {
      return 'assets/images/progress-pie-100.svg';
    }
  }
}
